module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- ';
 if(year == new Date().getFullYear()) { ;
__p += '\n	' +
((__t = ( window.format_date_diff(new Date() - new Date(year,1,1)) )) == null ? '' : __t) +
' מאז\n';
 } ;
__p += ' -->\n';
 up_down_arr = up_or_down(net_allocated,net_revised) ;
__p += '\n\nמתחילת ' +
((__t = ( year )) == null ? '' : __t) +
',\n' +
((__t = ( up_down_arr[0] )) == null ? '' : __t) +
'\nתקציב זה ' +
((__t = ( up_down_arr[1] )) == null ? '' : __t) +
' <strong class="approved">' +
((__t = ( number_with_commas(net_allocated*1000) )) == null ? '' : __t) +
' ₪</strong>\n';
 if(net_allocated != net_revised) { ;
__p += '\nל<strong class="' +
((__t = ( color_classname(net_revised-net_allocated) )) == null ? '' : __t) +
'">' +
((__t = ( number_with_commas(net_revised*1000) )) == null ? '' : __t) +
' ₪</strong>\n<br/>\n ועדת הכספים אישרה ' +
((__t = ( num_of_transfers_in_year_text(year) )) == null ? '' : __t) +
' בסך כולל של <strong><span>' +
((__t = ( number_with_commas((net_revised-net_allocated)*1000) )) == null ? '' : __t) +
'' +
((__t = ( number_plus_minus(net_revised-net_allocated) )) == null ? '' : __t) +
'</span> ₪ </strong>\n';
 if (net_allocated > 0) { ;
__p += '\n    , לכדי <strong class="' +
((__t = ( color_classname(net_revised-net_allocated) )) == null ? '' : __t) +
'">' +
((__t = ( parseInt(Math.abs( (net_revised/net_allocated)) * 100) )) == null ? '' : __t) +
'%' +
((__t = ( up_or_down_arrow(net_revised,net_allocated) )) == null ? '' : __t) +
'</strong> מהתקציב המקורי\n';
 } ;
__p += '\n<br/>\n';
 } ;
__p += '\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/header__current_budget.html
// module id = 136
// module chunks = 0